;(function (angular, _) {
  'use strict'
  angular.module('kilo.common.directives')
    .directive('lineDragDrop', LineDragDropDirective)
    .directive('lineDrag', LineDragDirective)

  LineDragDropDirective.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]

  function LineDragDropDirective (
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return {
      controller: function () {},
      scope: {},
      controllerAs: 'lineDropCtrl',
      bindToController: {
        lineDrop: '&'
      },
      link: function (scope, element) {
        var el = element[0]

        if (scope.lineDropCtrl.lineDrop) {
          el.addEventListener(
            'drop',
            function (e) {
              e.preventDefault()
              e.stopPropagation()
              if (e.stopPropagation) e.stopPropagation()
              this.classList.remove('over')
              scope.$apply(function () {
                scope.lineDropCtrl.lineDrop({$data: JSON.parse(e.dataTransfer.getData('Text')), $event: e})
              })
              return false
            },
            false
          )

          el.addEventListener(
            'dragenter',
            function (e) {
              this.classList.add('over')
              return false
            },
            false
          )

          el.addEventListener(
            'dragleave',
            function (e) {
              this.classList.remove('over')
              return false
            },
            false
          )
        }
      }
    }
  }

  LineDragDirective.$inject = [
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ]

  function LineDragDirective (
    // Angular
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
  ) {
    return {
      restrict: 'A',
      controller: function () {},
      bindToController: {
        lineDrag: '='
      },
      scope: true,
      controllerAs: 'lineDragController',
      link: function (scope, element, attrs) {
        var el = element[0]
        el.draggable = true

        el.addEventListener(
          'dragstart',
          function (e) {
            e.dataTransfer.effectAllowed = 'move'
            e.dataTransfer.setData('Text', JSON.stringify(scope.lineDragController.lineDrag))
            e.dataTransfer.setDragImage(el.closest('tr'), 0, 0)
            this.classList.add('drag')
            return false
          },
          false
        )

        el.addEventListener(
          'dragend',
          function (e) {
            this.classList.remove('drag')
            return false
          },
          false
        )

        el.addEventListener(
          'dragover',
          function (e) {
            e.dataTransfer.dropEffect = 'move'
            if (e.preventDefault) e.preventDefault()
            this.classList.add('over')
            return false
          },
          false
        )
      }
    }
  }
})(window.angular, window._)
